export default [
  {
    className: 'input-wrapper',
    htmlFor: 'name',
    html: 'Name',
    placeholder: 'Enter the name for your Property',
    name: 'name',
    type: 'text'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'rent',
    html: 'Rent',
    placeholder: 'Enter the rent for your property',
    name: 'rent',
    type: 'number'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'street',
    html: 'Street',
    placeholder: 'Street address',
    name: 'street_address',
    type: 'text'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'city',
    html: 'City',
    placeholder: 'City',
    name: 'city',
    type: 'text'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'zip',
    html: 'Zip',
    placeholder: 'Enter a 5-digit Zip Code',
    name: 'zip',
    type: 'text'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'state',
    html: 'State',
    placeholder: 'State',
    name: 'state',
    type: 'text',
    touched: 'state'
  },
  {
    className: 'input-wrapper',
    htmlFor: 'occupied',
    html: 'Occupants',
    placeholder: 'Number of occupants',
    name: 'occupied',
    type: 'text'
  }
];
